var _path, _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6306_42753",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 22,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2H2.5C3.29577 2 4.05864 2.31618 4.62117 2.87871C4.94052 3.19806 5.18054 3.58205 5.32836 4H19.5H19.5008C19.9559 4.00035 20.4048 4.1043 20.8137 4.30376C21.2225 4.50321 21.5809 4.79311 21.8614 5.15162C22.1419 5.51019 22.3368 5.92771 22.432 6.37249C22.5242 6.8035 22.5203 7.2495 22.4206 7.67871L21.4263 13.6444C21.4221 13.6698 21.4169 13.6951 21.4107 13.72C21.2499 14.3704 20.8761 14.9483 20.3487 15.3615C19.8213 15.7747 19.1707 15.9995 18.5008 16H18.5H6.5C5.70444 16 4.94126 15.684 4.37859 15.1214C3.81588 14.5586 3.5 13.7955 3.5 13V5C3.5 4.73499 3.39464 4.48061 3.20696 4.29292C3.01934 4.1053 2.7651 4 2.5 4H1.5V2ZM7.5 19C6.94772 19 6.5 19.4477 6.5 20C6.5 20.5523 6.94772 21 7.5 21C8.05229 21 8.50001 20.5523 8.50001 20C8.50001 19.4477 8.05229 19 7.5 19ZM4.5 20C4.5 18.3431 5.84315 17 7.5 17C9.15685 17 10.5 18.3431 10.5 20C10.5 21.6569 9.15685 23 7.5 23C5.84315 23 4.5 21.6569 4.5 20ZM17.5 19C16.9477 19 16.5 19.4477 16.5 20C16.5 20.5523 16.9477 21 17.5 21C18.0523 21 18.5 20.5523 18.5 20C18.5 19.4477 18.0523 19 17.5 19ZM14.5 20C14.5 18.3431 15.8431 17 17.5 17C19.1569 17 20.5 18.3431 20.5 20C20.5 21.6569 19.1569 23 17.5 23C15.8431 23 14.5 21.6569 14.5 20Z",
    fill: "#3F3F3F"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6306_42753)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.6667,
    height: 30.6667,
    transform: "translate(-3.33334 -3.8335)",
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.33334,
    y: -3.8335,
    width: 30.6667,
    height: 30.6667,
    fill: "#CD3438"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6306_42753",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -4,
    width: 32,
    height: 31
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -3.33334,
    y: -3.8335,
    width: 30.6667,
    height: 30.6667,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6306_42753)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.7222,
    cy: 21.7222,
    rx: 21.7222,
    ry: 21.7222,
    transform: "matrix(-1 0 0 1 49.0556 -25.5557)",
    fill: "url(#paint0_linear_6306_42753)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6306_42753",
    x1: 43.4445,
    y1: 0,
    x2: 0.00000370176,
    y2: 46.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.1f868abfcc968514876a80e92babf56d.svg";
export { ForwardRef as ReactComponent };